import "./Style/__sidebar.scss";
import { startAccessMonitoringActivity } from "./Auth/accessMonitoringActivity";
import React from "react";
import { Toaster } from "react-hot-toast";
import { PageTitle, AuthenticatedPages } from "./Components/AppNavigation";
import MenuAccessGate from "./Components/MenuAccessGate";
import MenuRouteGate from "./Components/MenuRouteGate";
import SideMenu from "../src/SidebarMenu/SideMenu";
import Header from "../src/SidebarMenu/Header";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import VatRates from "./CRUD/VatRates/VatRates";
import Homee from "../src/dashboard/pages/home/Home";
import Login from "./Auth/Login";
import States from "./CRUD/States/States";
import Cities from "./CRUD/Cities/Cities";
import ArticleGroups from "./CRUD/ArticleGroups/ArticleGroups";
import ArticleUnits from "./CRUD/ArticleUnits/ArticleUnits";
import Ledgers from "./CRUD/Ledgers/Ledgers";
import Article from "./CRUD/Article/Article";
import Users from "./CRUD/Users/Users";
import Accounts from "./CRUD/Accounts/Accounts";
import Clients from "./CRUD/Clients/Clients";
import Suppliers from "./CRUD/Suppliers/Suppliers";
import Banks from "./CRUD/Banks/Banks";
import CashRegister from "./CRUD/CashRegister/CashRegister";
import Owners from "./CRUD/Owners/Owners";
import Employees from "./CRUD/Employees/Employees";
import Tenants from "./CRUD/Tenants/Tenants";
import LicencedBanks from "./CRUD/LicencedBanks/LicencedBanks";
import Companies from "./CRUD/Companies/Companies";
import CompanyUnit from "./CRUD/CompanyUnit/CompanyUnit";
// import Expence from "./CRUD/Expenses/Expences";
import LongTermAssets from "./CRUD/LongTermAssets/LongTermAssets";
// import ExpensePurchases from "./CRUD/ExpensePurchases/ExpensePurchases";
import AccountReports from "./CRUD/Accounting Reports/AccountsReport";
import BanksReport from "./CRUD/Accounting Reports/BanksReport";
import AccountsReceivable from "./CRUD/Accounting Reports/AccountsReceivable";
import MoneyInCash from "./CRUD/Accounting Reports/MoneyInCash";
// import AddExpensePurchases from "../src/CRUD/ExpensePurchases/CreateAddExpencePurchase";
// import EditPurchaseExpence from "./CRUD/ExpensePurchases/EditPurchaseExpence";
// import SalesInTotal from "./CRUD/SalesInTotal/SalesInTotal";
// import AddSalesInTotal from "./CRUD/SalesInTotal/AddSalesInTotal";
// import InvestmentPurchases from "./CRUD/InvestmentPurchases/InvestmentPurchases";
// import AddInvestmentPurchase from "./CRUD/InvestmentPurchases/AddInvestmentPurchase";
// import DebitNote from "./CRUD/DebitNote/DebitNote";
// import InsertDebitNote from "./CRUD/DebitNote/InsertDebitNote";
// import CreditNote from "./CRUD/CreditNote/CreditNote";
// import InsertCreditNote from "./CRUD/CreditNote/InsertCreditNote";
import AccountsPartners from "./CRUD/Accounting Reports/AccountsPartners";
// import PurchaseInTotal from "./CRUD/PurchaseInTotal/PurchaseInTotal";
// import AddPurchaseInTotal from "./CRUD/PurchaseInTotal/AddPurchaseInTotal";
// import Advance from "./CRUD/Advance/Advance";
// import AddAdvance from "./CRUD/Advance/AddAdvance";
import Profile from "./CRUD/Profile/Profile";
import AccountingSheets from "./CRUD/AccountingSheet/AccountingSheets";
import AddAccountingSheet from "./CRUD/AccountingSheet/AddAccountingSheet";
import Rent from "./CRUD/Rent/Rent";
import AddRent from "./CRUD/Rent/AddRent";
import SalesBook from "./CRUD/AccountingBooks/SalesBook";
import ExpenceBook from "./CRUD/AccountingBooks/ExpenceBook";
import PurchaseBook from "./CRUD/AccountingBooks/PurchaseBook";
import InvestmentBook from "./CRUD/AccountingBooks/InvestmentBook";
import PurchaseDetail from "./CRUD/PurchaseDetail/PurchaseDetail";
import AddPurchaseDetail from "./CRUD/PurchaseDetail/AddPurchaseDetail";
import SalesInDetails from "./CRUD/SalesInDetails/SalesInDetails";
import AddSalesInDetails from "./CRUD/SalesInDetails/AddSalesInDetails";
import PrintContent from "./Print/PrintContent";
import TaxSalesBook from "./CRUD/Tax Reports/TaxSalesBook";
import TaxPurchaseBook from "./CRUD/Tax Reports/TaxPurchaseBook";
import VATDeclaration from "./CRUD/Tax Reports/VATDeclaration";
import TrialBalance from "./CRUD/Finance Statements/TrialBalance";
import BalanceSheet from "./CRUD/Finance Statements/BalanceSheet";
import IncomeStatements from "./CRUD/Finance Statements/IncomeStatements";
import JournalHistory from "./CRUD/Accounting Reports/JournalHistory";
import AnnualDeclaration from "./CRUD/Tax Reports/AnnualDeclaration";
import Inventory from "./CRUD/Accounting Reports/Inventory";
import CoverPage from "./Print/CoverPage";
import Z_SalesDeail from "./CRUD/Z_SalesDetail/Z_SalesDetail";
import Insert_ZSalesDetail from "./CRUD/Z_SalesDetail/InsertZ_SalesDetail";
import AddReceivables from "./CRUD/Receivables/AddReceivables";
import Receivables from "./CRUD/Receivables/Receivables";
import Payments from "./CRUD/Payments/Payments";
import AddPayments from "./CRUD/Payments/AddPayments";
import Withdrawal from "./CRUD/Withdrawal/Withdrawal";
import AddWithdrawal from "./CRUD/Withdrawal/AddWithdrawal";
import Transfers from "./CRUD/Transfers/Transfers";
import AddTransfer from "./CRUD/Transfers/AddTransfers";
import LinkInvoice from "./pages/LinkInvoice";
import FletHyrje from "./CRUD/FletHyrja/FletHyrje";
import InsertEntrySheet from "./CRUD/FletHyrja/InsertEntrySheet";
import FletDalja from "./CRUD/FletëDalja/FletDalja";
import InsertExitSheet from "./CRUD/FletëDalja/InsertExitSheet";
import Wages from "./CRUD/Wages/Wages";
import AddWages from "./CRUD/Wages/AddWages";
import AddProInvoices from "./CRUD/Pro Invoices/AddProInvoices";
import ProInvoices from "./CRUD/Pro Invoices/ProInvoices";
import Oferta from "./CRUD/Oferta/Oferta";
import AddOferta from "./CRUD/Oferta/AddOferta";
import Import from "./CRUD/Import/Import";
import AddImport from "./CRUD/Import/AddImport";
import MonthlySalesReport from "./CRUD/Finance Statements/MonthlySalesReport";
import MonthlyPurchaseReport from "./CRUD/Finance Statements/MonthlyPurchaseReport";
import MonthlyExpenseReport from "./CRUD/Finance Statements/MonthlyExpenseReport";
import MonthlyWagesReport from "./CRUD/Finance Statements/MonthlyWagesReport";
import MonthlyRentReport from "./CRUD/Finance Statements/MonthlyRentReport";
import MonthlyExpenseClassReport from "./CRUD/Finance Statements/MonthlyExpenseClassReport";
// import POS from "./CRUD/POS/POS";
import POSPage from "./NewCRUD/POSCRUD/POSPage";
import AddPos from "./CRUD/POS/AddPos";
import TaxWagesReport from "./CRUD/Tax Reports/TaxWagesReport";
import KartelaKlientit from "./CRUD/Kartelat/KartelaKlientit";
import KartelaFurnitorit from "./CRUD/Kartelat/KartelaFurnitorit";
import KartelaAgjentit from "./CRUD/Kartelat/KartelaAgjentit";
import WagesAccount from "./CRUD/Accounting Reports/WagesAccount";
import RentAccounts from "./CRUD/Accounting Reports/RentAccounts";
// import FolderatFizik from "./Print/FolderatFizik";
// import NoPage from "./pages/NoPage";
import MonthlyInteresReport from "./CRUD/Finance Statements/MonthlyInteresReport";
import FixedAssets from "./CRUD/Finance Statements/FixedAssets";
import AddSalesInDetails_NoterModule from "./CRUD/Noter_Module/AddSalesInDetails_NoterModule";
import SalesInDetails_NoterModule from "./CRUD/Noter_Module/SalesInDetails_NoterModule";
import getCompanyModule from "./Auth/GetCompanyModule";
import authHeader from "./Auth/authHeader";
import ClientBranches from "./CRUD/ClientBranches/ClientBranches";
import Interes from "./CRUD/Interes/interes";
import InsertInteres from "./CRUD/Interes/InsertInteres";
import InsertOfficialRent from "./CRUD/Rent/InsertOfficialRent";
import InsertKthimiMallitNgaKlienti from "./CRUD/KthimM.Klienti/InsertKthimiMallitNgaKlienti";
import KthimiMallitNgaKlienti from "./CRUD/KthimM.Klienti/KthimiMallitNgaKlienti";
import InsertReturnToSupplier from "./CRUD/KthimTekFurnitori/InsertReturnToSupplier";
import ReturnToSupplier from "./CRUD/KthimTekFurnitori/ReturnToSupplier";
import CompoundArticle from "./Produce/StandartProduction/CompoundArticle/CompoundArticle";
import Normativ from "./Produce/StandartProduction/Normativ/Normativ";
import NewNormativ from "./Produce/StandartProduction/Normativ/NewNormativ";
import Produce from "./Produce/StandartProduction/Prodhim/Produce";
import NewProduce from "./Produce/StandartProduction/Prodhim/NewProduce";
import MillNormativ from "./Produce/MillProduction/Normativ/MillNormativ";
import NewMillNormativ from "./Produce/MillProduction/Normativ/NewMillNormativ";
import MillProduce from "./Produce/MillProduction/Prodhim/MillProduce";
import NewMillProduce from "./Produce/MillProduction/Prodhim/NewMillProduce";
import CapitalDeposite from "./CRUD/CapitalDeposit/CapitalDeposit";
import AddCapitalDeposit from "./CRUD/CapitalDeposit/AddCapitalDeposit";
import NdryshimiEkuitetit from "./CRUD/Tax Reports/NdryshimiEkuitetit";
import BartjaLlogarive from "./NewCRUD/NewFiscalYear/BartjaLlogarive";
import AddImportiInvestiv from "./CRUD/ImportiInvestiv/AddImportiInvestiv";
import ImportInvestiv from "./CRUD/ImportiInvestiv/ImportInvestiv";
import KartelaArtikullit from "./CRUD/Kartelat/KartelaArtikullit";
import FiscalCashRegister from "./CRUD/FiscalCashRegister/FiscalCashRegister";
import BartjaStokut from "./NewCRUD/NewFiscalYear/BartjaStokut";
import ImportimiArtikujve from "./NewCRUD/NewFiscalYear/ImportimiArtikujve";
import ImportimiPartnereve from "./NewCRUD/NewFiscalYear/PartnerImport/ImportimiPartnereve";
import FarmerPurchase from "./CRUD/Moduli_Mullirit/FarmerPurchase/FarmerPurchase";
import NoPage from "./pages/NoPage";
import AddFarmerPurchase from "./CRUD/Moduli_Mullirit/FarmerPurchase/AddFarmerPurchase";
import EmployeeContracts from "./CRUD/Employees/EmployeeContracts";
import Notification from "./CRUD/Notification/Notification";
import DataLayouts from "./Layouts/DataLayouts";
import AddAutomaticWages from "./CRUD/Wages/AddAutomaticWages";
import NewCompany from "./CRUD/Companies/NewCompany";
import NewLicens from "./NewCRUD/CompaniesCRUD/NewLicens";
import InsertNewOrdinanceUser from "./CRUD/Moduli__Ordinanca/InsertNewOrdinanceUser";
import MenuItemsPage from "./CRUD/System_MenuItem/MenuItemsPage";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setupAxiosInterceptors } from "./Auth/axiosInterceptor";
import { startInactivityLogout } from "./Auth/inactivityService";

//Format e reja fillojn nga ketu
import UnitsPage from "./NewCRUD/UnitCRUD/UnitsPage";
import ArticleGroupsPage from "./NewCRUD/ArticleGroupsCRUD/ArticleGroupsPage";
import ArticlePage from "./NewCRUD/ArticleCRUD/ArticlePage";
import LayoutNavbar from "./SidebarMenu/LayoutNavbar";
import ClientsPage from "./NewCRUD/ClientsCRUD/ClientsPage";
import SuppliersPage from "./NewCRUD/SuppliersCRUD/SuppliersPage";
import CashRegisterPage from "./NewCRUD/CashRegisterCRUD/CashRegisterPage";
import BanksPage from "./NewCRUD/BanksCRUD/BanksPage";
import OwnersPage from "./NewCRUD/OwnersCRUD/OwnersPage";
import TenantsPage from "./NewCRUD/TenantsCRUD/TenantsPage";
import EmployeesPage from "./NewCRUD/EmployeesCRUD/EmployeesPage";
import OtherAccountsPage from "./NewCRUD/OtherAccountsCRUD/OtherAccountsPage";
import ClientBranchesPage from "./NewCRUD/ClientBranchesCRUD/ClientBranchesPage";
import CompanyProfilePage from "./NewCRUD/CompanyConfiguration/CompanyProfilePage";
import DashboardPage from "./NewCRUD/NewDashboard/DashboardPage";
import FolderTemplatesPage from "./NewCRUD/NewTemplates/FolderTemplatesPage";
import PurchaseExpenceForm from "./NewCRUD/ExpencePurchaseCRUD/ExpencePurchaseComponents/PurchaseExpenceForm";
import ExpensePurchasesPage from "./NewCRUD/ExpencePurchaseCRUD/ExpensePurchasesPage";
import ExpenceTypePage from "./NewCRUD/ExpensesTypeCRUD/ExpencesTypePage";
import PurchaseInTotalForm from "./NewCRUD/PurchaseInTotalCRUD/PurchaseInTotalForm";
import PurchaseInTotalPage from "./NewCRUD/PurchaseInTotalCRUD/PurchaseInTotalPage";
import InvestmentPurchaseTotalPage from "./NewCRUD/InvestmentPurchasesTotalCRUD/InvestmentPurchasesTotalPage";
import InvestmentPurchaseTotalForm from "./NewCRUD/InvestmentPurchasesTotalCRUD/InvestmentPurchaseTotalForm";
import LongTermAssetsPage from "./NewCRUD/LongTermAssetsCRUD/LongTermAssetsPage";
import SalesInTotalPage from "./NewCRUD/SalesInTotalCRUD/SalesInTotalPage";
import SalesInTotalForm from "./NewCRUD/SalesInTotalCRUD/SalesInTotalForm";
import AdvancePage from "./NewCRUD/AdvanceCRUD/AdvancePage";
import AdvanceForm from "./NewCRUD/AdvanceCRUD/AdvanceForm";
import DebitNotePage from "./NewCRUD/DebitNote/DebitNotePage";
import DebitNoteForm from "./NewCRUD/DebitNote/DebitNoteForm";
import BalanceSheetPage from "./NewCRUD/FinancialStatementCRUD/BalanceSheetPage";
import IncomeStatementPage from "./NewCRUD/FinancialStatementCRUD/IncomeStatementPage";
import CashFlowPage from "./NewCRUD/FinancialStatementCRUD/CashFlowPage";
import EquityChangesPage from "./NewCRUD/FinancialStatementCRUD/EquityChangesPage";
import FinancialStatementsNotes from "./NewCRUD/FinancialStatementCRUD/FinancialStatementsNotes";
import CreditNotePage from "./NewCRUD/CreditNoteCRUD/CreditNotePage";
import CreditNoteForm from "./NewCRUD/CreditNoteCRUD/CreditNoteForm";
import CompoundArticlePage from "./NewCRUD/Moduli_Prodhimit/Prodhimi_Standard/CompoundArticle/CompoundArticlePage";
import StandardNormativPage from "./NewCRUD/Moduli_Prodhimit/Prodhimi_Standard/Normativ/StandardNormativPage";
import StandardNormativForm from "./NewCRUD/Moduli_Prodhimit/Prodhimi_Standard/Normativ/StandardNormativForm";
import StandardProducePage from "./NewCRUD/Moduli_Prodhimit/Prodhimi_Standard/Prodhimi_Standard/StandardProducePage";
import StandardProduceForm from "./NewCRUD/Moduli_Prodhimit/Prodhimi_Standard/Prodhimi_Standard/StandardProduceForm";
import VatDeclarationPage from "./NewCRUD/TaxReports/VATDeclarationPage";
import AnnualDeclarationPage from "./NewCRUD/TaxReports/AnnualDeclarationPage";
import VATMonthlySyntheticPage from "./NewCRUD/TaxReports/VATMonthlySyntheticPage";
import ReceivablesPage from "./NewCRUD/ReceivablesCRUD/ReceivablesPage";
import ReceivablesForm from "./NewCRUD/ReceivablesCRUD/ReceivablesForm";
import PaymentsPage from "./NewCRUD/PaymentsCRUD/PaymentsPage";
import PaymentsForm from "./NewCRUD/PaymentsCRUD/PaymentsForm";
import WithdrawalPage from "./NewCRUD/WithdrawalCRUD/WithdrawalPage";
import WithdrawalForm from "./NewCRUD/WithdrawalCRUD/WithdrawalForm";
import TransfersPage from "./NewCRUD/TransfersCRUD/TransfersPage";
import TransfersForm from "./NewCRUD/TransfersCRUD/TransfersForm";
import SalesReconciliationPage from "./NewCRUD/CashReconciliationCRUD/SalesReconciliationPage";
import CapitalDepositePage from "./NewCRUD/CapitalDepositCRUD/CapitalDepositPage";
import CapitalDepositForm from "./NewCRUD/CapitalDepositCRUD/CapitalDepositForm";
import SalesBookPage from "./NewCRUD/AccountingBooksCRUD/SalesBookPage";
import PurchaseBookPage from "./NewCRUD/AccountingBooksCRUD/PurchaseBookPage";
import ExpenceBookPage from "./NewCRUD/AccountingBooksCRUD/ExpenceBookPage";
import InvestmentBookPage from "./NewCRUD/AccountingBooksCRUD/InvestmentBookPage";
import TaxSalesBookPage from "./NewCRUD/TaxReports/TaxSalesBookPage";
import TaxPurchaseBookPage from "./NewCRUD/TaxReports/TaxPurchaseBookPage";
import TaxWagesReportPage from "./NewCRUD/TaxReports/TaxWagesReportPage";
import JournalHistoryPage from "./NewCRUD/AccountingReportsCRUD/JournalHistoryPage";
import InventoryPage from "./NewCRUD/AccountingReportsCRUD/InventoryPage";
import AccountsReport from "./CRUD/Accounting Reports/AccountsReport";
import AccountsReportPage from "./NewCRUD/AccountingReportsCRUD/AccountsReportPage";
import AccountsReceivablePage from "./NewCRUD/AccountingReportsCRUD/AccountsReceivablePage";
import AccountsPartnersPage from "./NewCRUD/AccountingReportsCRUD/AccountsPartnersPage";
import WagesAccountPage from "./NewCRUD/AccountingReportsCRUD/WagesAccountPage";
import RentAccountsPage from "./NewCRUD/AccountingReportsCRUD/RentAccountsPage";
import BanksReportPage from "./NewCRUD/AccountingReportsCRUD/BanksReportPage";
import MoneyInCashPage from "./NewCRUD/AccountingReportsCRUD/MoneyInCashPage";
import ProductionReportPage from "./NewCRUD/AccountingReportsCRUD/ProductionReportPage";
import TrialBalancePage from "./NewCRUD/FinancialStatementCRUD/TrialBalancePage";
import NewCompanyForm from "./NewCRUD/CompaniesCRUD/NewCompanyForm";
import CompaniesPage from "./NewCRUD/CompaniesCRUD/CompaniesPage";
import LicensesPage from "./NewCRUD/CompaniesCRUD/LicensesPage";
import ProductRenewalsPage from "./NewCRUD/CompaniesCRUD/ProductRenewalsPage";
import MonthlyRentReportPage from "./NewCRUD/FinancialStatementCRUD/MonthlyRentReportPage";
import MonthlySalesReportPage from "./NewCRUD/FinancialStatementCRUD/MonthlySalesReportPage";
import MonthlyPurchaseReportPage from "./NewCRUD/FinancialStatementCRUD/MonthlyPurchaseReportPage";
import MonthlyExpenseReportPage from "./NewCRUD/FinancialStatementCRUD/MonthlyExpenseReportPage";
import MonthlyWagesReportPage from "./NewCRUD/FinancialStatementCRUD/MonthlyWagesReportPage";
import MonthlyExpenseClassReportPage from "./NewCRUD/FinancialStatementCRUD/MonthlyExpenseClassReportPage";
import MonthlyInteresReportPage from "./NewCRUD/FinancialStatementCRUD/MonthlyInteresReportPage";
import FixedAssetsPage from "./NewCRUD/FinancialStatementCRUD/FixedAssetsPage";
import KartelaArtikullitPage from "./NewCRUD/KartelatCRUD/KartelaArtikullitPage";
import ClientCardPage from "./NewCRUD/KartelatCRUD/ClientCardPage";

const Dashboard = () => <Homee />;

const ArticlesList = () => <Article />;
const ArticleGroupCruds = () => <ArticleGroups />;
const ArticleUnitCruds = () => <ArticleUnits />;
const VATRatesCruds = () => <VatRates />;
const StatesCrud = () => <States />;
const CitiesCrud = () => <Cities />;

const AccountsList = () => <Accounts />;
const ClientsList = () => <Clients />;
const SuppliersList = () => <Suppliers />;
const BankList = () => <Banks />;
const CashRegisterList = () => <CashRegister />;
const OwnerList = () => <Owners />;
const EmployeesList = () => <Employees />;
const TenantsList = () => <Tenants />;
const LicencedBanksList = () => <LicencedBanks />;
const CompaniesList = () => <Companies />;
const CompanyUnitLists = () => <CompanyUnit />;
// const ExpenceList = () => <Expence />;
const LongTermAssetsList = () => <LongTermAssets />;
// const ExpensePurchasesList = () => <ExpensePurchases />;
// const PurchaseInTotalList = () => <PurchaseInTotal />;
// const SalesInTotalList = () => <SalesInTotal />;
// const InvestmentPurchasesList = () => <InvestmentPurchases />;
// const DebitNoteList = () => <DebitNote />;
// const CreditNoteList = () => <CreditNote />;
// const AdvanceList = () => <Advance />;
const AccountingSheetList = () => <AccountingSheets />;
const SalesBookList = () => <SalesBook />;
const ExpenceBookList = () => <ExpenceBook />;
const PurchaseBookList = () => <PurchaseBook />;
const InvestmentBookList = () => <InvestmentBook />;
const RentList = () => <Rent />;
const PurchaseDetailList = () => <PurchaseDetail />;
// const SalesInDetailsList = () => <SalesInDetails />

//Raports
// const TrialBalanceList = () => <TrialBalance />;
const AccountReportsList = () => <AccountReports />;
const BanksReportList = () => <BanksReport />;
const AccountsReceivableList = () => <AccountsReceivable />;
const MoneyInCashList = () => <MoneyInCash />;

const UsersList = () => <Users />;

const Loggin = () => <Login />;
const AccessMonitoringPage = React.lazy(() => import("./AccessMonitoring/AccessMonitoringPage"));
const CompanyStoragePage = React.lazy(() => import("./SystemMonitoring/CompanyStoragePage"));
const TableStoragePage = React.lazy(() => import("./SystemMonitoring/TableStoragePage"));
const NotesPage = React.lazy(() => import("./Notes/NotesPage"));
const SupportPage = React.lazy(() => import("./Support/SupportPage"));
const SupportTicketDetailPage = React.lazy(() => import("./Support/SupportTicketDetailPage"));
const SupportAdminPage = React.lazy(() => import("./Support/SupportAdminPage"));
const SupportAdminTicketPage = React.lazy(() => import("./Support/SupportAdminTicketPage"));

function App() {
  useEffect(() => startAccessMonitoringActivity(), []);
  const [inactive, setInactive] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const headers = authHeader();

  const history = useHistory();

  const [module, setModule] = useState("");
  const [moduleLoaded, setModuleLoaded] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      setInactive(true);
    }
  }, [isLoggedIn]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  // useEffect(() => {
  //   getCompanyModule(headers).then(setModule)
  // }, []);

  useEffect(() => {
    if (isLoggedIn) {
      getCompanyModule(headers).then(setModule).finally(() => setModuleLoaded(true));
    }
  }, [isLoggedIn]);

  useEffect(() => {
    setupAxiosInterceptors();

    if (localStorage.getItem("token")) {
      return startInactivityLogout();
    }
  }, []);

  return (
    <div className="App">
      <Toaster
        position="top-right"
        toastOptions={{ style: { maxWidth: 480 } }}
      />
      <Router>
        <PageTitle />
        <Switch>
          {/* Rruga për Invoice e cila shfaqet pa Sidebar dhe Header */}
          <Route path={"/invoice"} render={() => <LinkInvoice />} />

          <Route path={"/Sales/addPos"} render={() => isLoggedIn
            ? <MenuRouteGate><AddPos /></MenuRouteGate>
            : <Loggin onLoginSuccess={handleLoginSuccess} />} />

          {/* Kontrolli i Logimit për të tjerat */}
          {!isLoggedIn ? (
            <Route
              path="/"
              component={() => <Loggin onLoginSuccess={handleLoginSuccess} />}
            />
          ) : (
            <LayoutNavbar>
              <AuthenticatedPages ready={moduleLoaded}>
              <MenuRouteGate moduleName={module} moduleReady={moduleLoaded}>
              <Route exact path="/admin/access-monitoring" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar monitorimin…</div>}>
                  <AccessMonitoringPage />
                </React.Suspense>} />
              <Route exact path="/admin/company-storage" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar hapësirën…</div>}>
                  <CompanyStoragePage />
                </React.Suspense>} />
              <Route exact path="/admin/table-storage" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar tabelat…</div>}>
                  <TableStoragePage />
                </React.Suspense>} />
              <Route exact path="/notes" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar shënimet…</div>}>
                  <NotesPage />
                </React.Suspense>} />
              <Route exact path="/support" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar suportin…</div>}>
                  <SupportPage />
                </React.Suspense>} />
              <Route exact path="/support/tickets/:id" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar tiketën…</div>}>
                  <SupportTicketDetailPage />
                </React.Suspense>} />
              <Route exact path="/support/admin" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar menaxhimin e suportit…</div>}>
                  <SupportAdminPage />
                </React.Suspense>} />
              <Route exact path="/support/admin/tickets/:id" render={() =>
                <React.Suspense fallback={<div role="status">Duke ngarkuar tiketën…</div>}>
                  <SupportAdminTicketPage />
                </React.Suspense>} />
              {/* Vendosni këtu të gjitha rrugët tjera që duan Sidebar dhe Header */}
              {/* <Route exact path={"/dashboard"} render={() => <Dashboard />} /> */}
              <Route
                exact
                path={"/dashboard"}
                render={() => <DashboardPage />}
              />
              {/* Article Menu------------------------------------------------------------------ */}
              {/* <Route path={"/articles/articleslist"} component={ArticlesList} /> */}

              {/* Forma e vjeter e artikujve */}
              {/* <Route
                  path={"/articles/articleslist"}
                  render={() => <ArticlesList />}
                /> */}
              {/* Forma e re e artikujve */}
              <Route
                path={"/articles/articleslist"}
                render={() => <ArticlePage />}
              />

              {/* <Route path={"/articles/articlegroups"} component={ArticleGroupCruds} /> */}
              {/* <Route
                  path={"/articles/articlegroups"}
                  render={() => <ArticleGroupCruds />}
                /> */}
              {/* Forma e re e grupeve */}
              <Route
                path={"/articles/articlegroups"}
                render={() => <ArticleGroupsPage />}
              />

              {/* <Route
                  path={"/articles/articleunits"}
                  component={ArticleUnits}
                /> */}
              {/* Forma e re e njesive */}
              <Route
                path={"/articles/articleunits"}
                render={() => <UnitsPage />}
              />

              {/* <Route path={"/articles/units"} component={ArticleUnitCruds} /> */}

              {/* Accounts Menu------------------------------------------------------------------ */}
              {/* <Route path={"/accounts/others"} component={AccountsList} /> */}
              <Route
                path={"/accounts/others"}
                render={() => <OtherAccountsPage />}
              />
              {/* <Route path={"/accounts/clients"} component={ClientsList} /> */}
              <Route
                path={"/accounts/clients"}
                render={() => <ClientsPage />}
              />
              {/* <Route
                path={"/accounts/clientUnits"}
                render={() => <ClientBranches />}
              /> */}

              <Route
                path={"/accounts/clientUnits"}
                render={() => <ClientBranchesPage />}
              />
              {/* <Route path={"/accounts/suppliers"} component={SuppliersList} /> */}
              <Route
                path={"/accounts/suppliers"}
                render={() => <SuppliersPage />}
              />
              {/* <Route path={"/accounts/banks"} component={BankList} /> */}
              <Route path={"/accounts/banks"} render={() => <BanksPage />} />
              {/* <Route
                path={"/accounts/cashregisters"}
                component={CashRegisterList}
              /> */}
              <Route
                path={"/accounts/cashregisters"}
                render={() => <CashRegisterPage />}
              />
              {/* <Route path={"/accounts/owners"} component={OwnerList} /> */}
              <Route path={"/accounts/owners"} render={() => <OwnersPage />} />

              {/* <Route path={"/accounts/employees"} component={EmployeesList} /> */}
              <Route
                path={"/accounts/employees"}
                render={() => <EmployeesPage />}
              />

              {/* <Route
                path={"/accounts/employees"}
                render={() => <TenantsPage />}
              /> */}

              <Route
                path="/employees/contracts/:accountId"
                component={EmployeeContracts}
              />

              {/* <Route path={"/accounts/thetenants"} component={TenantsList} /> */}
              <Route
                path={"/accounts/thetenants"}
                render={() => <TenantsPage />}
              />
              {/* <Route path={"/accounts/expences"} component={ExpenceList} /> */}
              <Route
                path={"/accounts/expences"}
                render={() => <ExpenceTypePage />}
              />
              {/* <Route
                path={"/accounts/longtermassets"}
                component={LongTermAssetsList}
              /> */}
              <Route
                path={"/accounts/longtermassets"}
                render={() => <LongTermAssetsPage />}
              />
              {/* Purchase Menu------------------------------------------------------------------ */}
              {/* <Route
                path={"/purchases/addexpensepurchases/edit"}
                component={EditPurchaseExpence}
              /> */}
              {/* <Route
                path={"/purchases/purchaseintotal"}
                component={PurchaseInTotalList}
              /> */}
              <Route
                exact
                path={"/purchases/purchaseintotal"}
                render={() => <PurchaseInTotalPage />}
              />
              {/* <Route
                path={"/purchases/purchaseintotal/new"}
                component={PurchaseInTotalForm}
              /> */}
              <Route
                exact
                path={"/purchases/purchaseintotal/edit/:transactionId"}
                render={() => <PurchaseInTotalForm />}
              />
              <Route
                exact
                path={"/purchases/purchaseintotal/new"}
                render={() => <PurchaseInTotalForm />}
              />
              {/* <Route
                path={"/purchases/investmentpurchases"}
                component={InvestmentPurchasesList}
              /> */}
              <Route
                exact
                path={"/purchases/investmentpurchases"}
                render={() => <InvestmentPurchaseTotalPage />}
              />
              <Route
                exact
                path={"/purchases/investmentpurchases/new"}
                render={() => <InvestmentPurchaseTotalForm />}
              />
              <Route
                exact
                path={"/purchases/investmentpurchases/edit/:transactionId"}
                render={() => <InvestmentPurchaseTotalForm />}
              />
              <Route
                path={"/purchases/addInvestmentImport"}
                render={() => <AddImportiInvestiv />}
              />
              <Route
                path={"/purchases/investmentImport"}
                render={() => <ImportInvestiv />}
              />

              <Route
                path={"/purchases/detailpurchase"}
                render={() => (
                  <MenuAccessGate path="/purchases/detailpurchase">
                    <PurchaseDetailList />
                  </MenuAccessGate>
                )}
              />
              <Route
                path={"/purchases/addpurchaseinvoice"}
                render={() => (
                  <MenuAccessGate path="/purchases/detailpurchase" action="add">
                    <AddPurchaseDetail />
                  </MenuAccessGate>
                )}
              />
              <Route path={"/purchases/import"} render={() => <Import />} />
              <Route
                path={"/purchases/addImport"}
                render={() => <AddImport />}
              />

              {module === "Mill_Module" ? (
                <>
                  <Route
                    path={"/purchases/FarmerPurchase"}
                    render={() => <FarmerPurchase />}
                  />
                  <Route
                    path={"/purchases/NewFarmerPurchase"}
                    render={() => <AddFarmerPurchase />}
                  />
                </>
              ) : null}

              {/* Expence Menu------------------------------------------------------------------ */}
              <Route
                exact
                path={"/expences/expensepurchases"}
                render={() => <ExpensePurchasesPage />}
              />
              <Route
                exact
                path={"/expences/expensepurchases/new"}
                render={() => <PurchaseExpenceForm />}
              />
              <Route
                path={"/expences/expensepurchases/edit/:transactionId"}
                render={() => <PurchaseExpenceForm />}
              />
              <Route
                exact
                path={"/expences/addexpensepurchases"}
                render={() => <ExpensePurchasesPage />}
              />
              {/* <Route
                path={"/expences/addexpensepurchases"}
                component={AddExpensePurchases}
              /> */}
              <Route
                exact
                path={"/expences/addexpensepurchases/new"}
                render={() => <PurchaseExpenceForm />}
              />
              <Route
                path={"/expences/addexpensepurchases/edit/:transactionId"}
                render={() => <PurchaseExpenceForm />}
              />
              <Route path={"/expences/rent"} component={RentList} />
              <Route path={"/expences/AddRent"} component={AddRent} />
              <Route
                path={"/expences/officialRent"}
                render={() => <InsertOfficialRent />}
              />
              <Route path={"/expences/wages"} render={() => <Wages />} />
              <Route path={"/expences/AddWages"} render={() => <AddWages />} />
              <Route path={"/expences/interes"} render={() => <Interes />} />
              <Route
                path={"/expences/AddInteres"}
                render={() => <InsertInteres />}
              />

              <DataLayouts>
                <Route
                  path={"/expences/automaticWages"}
                  render={() => <AddAutomaticWages />}
                />
              </DataLayouts>

              {/* Sales Menu------------------------------------------------------------------ */}
              {/* <Route
                path={"/Sales/salesintotal"}
                component={SalesInTotalList}
              /> */}
              <Route
                exact
                path={"/Sales/salesintotal"}
                render={() => <SalesInTotalPage />}
              />
              {/* <Route
                path={"/Sales/salesintotal/new"}
                component={AddSalesInTotal}
              /> */}
              <Route
                exact
                path={"/Sales/salesintotal/new"}
                render={() => <SalesInTotalForm />}
              />
              <Route
                path={"/Sales/salesintotal/edit/:transactionId"}
                render={() => <SalesInTotalForm />}
              />
              {/* <Route path={"/Sales/advance"} component={AdvanceList} /> */}
              <Route
                exact
                path={"/Sales/advance"}
                render={() => <AdvancePage />}
              />
              {/* <Route path={"/Sales/advance/new"} component={AddAdvance} /> */}
              <Route
                exact
                path={"/Sales/advance/new"}
                render={() => <AdvanceForm />}
              />
              <Route
                exact
                path={"/Sales/advance/edit/:transactionId"}
                render={() => <AdvanceForm />}
              />

              {/* <Route path={"/Sales/debitnote"} component={DebitNoteList} /> */}
              <Route
                exact
                path={"/Sales/debitnote"}
                render={() => <DebitNotePage />}
              />
              {/* <Route path={"/Sales/debitnote/new"} component={InsertDebitNote} /> */}
              <Route
                exact
                path={"/Sales/debitnote/new"}
                render={() => <DebitNoteForm />}
              />
              <Route
                exact
                path={"/Sales/debitnote/edit/:transactionId"}
                render={() => <DebitNoteForm />}
              />

              {/* <Route path={"/Sales/creditnote"} component={CreditNoteList} /> */}
              <Route
                exact
                path={"/Sales/creditnote"}
                render={() => <CreditNotePage />}
              />
              <Route
                exact
                path={"/Sales/creditnote/edit/:transactionId"}
                render={() => <CreditNoteForm />}
              />
              {/* <Route
                path={"/Sales/creditnote/new"}
                component={InsertCreditNote}
              /> */}
              <Route
                exact
                path={"/Sales/creditnote/new"}
                render={() => <CreditNoteForm />}
              />
              <Route
                path={"/Sales/newReturnFromCustomer"}
                render={() => <InsertKthimiMallitNgaKlienti />}
              />
              <Route
                path={"/Sales/returnFromCustomer"}
                render={() => <KthimiMallitNgaKlienti />}
              />
              <Route
                path={"/Sales/NewReturnToSupplier"}
                render={() => <InsertReturnToSupplier />}
              />
              <Route
                path={"/Sales/returnToSupplier"}
                render={() => <ReturnToSupplier />}
              />

              {/* <Route path={"/Sales/salesindetails"} component={SalesInDetailsList} /> */}
              {/* <Route path={"/Sales/Addsalesindetails"} component={AddSalesInDetails} /> */}
              <Route
                exact
                path={"/notary/salesindetails"}
                render={() => <SalesInDetails_NoterModule />}
              />
              {module === "Notary_Module" ? (
                <>
                  <Route
                    path={"/Sales/salesindetails"}
                    render={() => <SalesInDetails_NoterModule />}
                  />
                  <Route
                    path={"/Sales/Addsalesindetails"}
                    render={() => <AddSalesInDetails_NoterModule />}
                  />
                </>
              ) : (
                <>
                  {/* <DataLayouts>
                        <Route path={"/Sales/Addsalesindetails"} render={() => <AddSalesInDetails />} />
                        <Route path={"/Sales/salesindetails"} render={() => <SalesInDetails />} />
                      </DataLayouts> */}

                  <Route
                    path={"/Sales/Addsalesindetails"}
                    render={() => <AddSalesInDetails />}
                  />
                  <Route
                    path={"/Sales/salesindetails"}
                    render={() => <SalesInDetails />}
                  />
                </>
              )}

              {/* <Route path={"/Sales/Addsalesindetails"} component={AddSalesInDetails} /> */}
              <Route
                path={"/Sales/Z-salesdetail"}
                render={() => <Z_SalesDeail />}
              />
              <Route
                path={"/Sales/add-Z-sales"}
                render={() => <Insert_ZSalesDetail />}
              />
              <Route
                path={"/Sales/proInvoice"}
                render={() => <ProInvoices />}
              />
              <Route
                path={"/Sales/addProInvoice"}
                render={() => <AddProInvoices />}
              />
              <Route path={"/Sales/offer"} render={() => <Oferta />} />
              <Route path={"/Sales/Addoffer"} render={() => <AddOferta />} />
              {/* <Route path={"/Sales/pos"} render={() => <POS />} /> */}
              <Route path={"/Sales/pos"} render={() => <POSPage />} />
              {/* <Route path={"/Sales/addPos"} render={() => <AddPos />} /> */}

              {/* Reports Menu------------------------------------------------------------------ */}
              {/* <Route
                path={"/Reports/accountspayable"}
                component={AccountReportsList}
              /> */}

              <Route
                path={"/Reports/accountspayable"}
                render={() => <AccountsReportPage />}
              />

              {/* <Route
                path={"/Reports/accountsreceivable"}
                component={AccountsReceivableList}
              /> */}

              <Route
                path={"/Reports/accountsreceivable"}
                render={() => <AccountsReceivablePage />}
              />
              {/* <Route path={"/Reports/moneybank"} component={BanksReportList} /> */}
              <Route
                path={"/Reports/moneybank"}
                render={() => <BanksReportPage />}
              />
              {/* <Route path={"/Reports/cashmoney"} component={MoneyInCashList} /> */}
              <Route
                path={"/Reports/cashmoney"}
                render={() => <MoneyInCashPage />}
              />
              <Route
                path={"/Reports/production-report"}
                render={() => <ProductionReportPage />}
              />
              {/* <Route
                path={"/Reports/accountspartners"}
                component={AccountsPartners}
              /> */}
              <Route
                path={"/Reports/accountspartners"}
                render={() => <AccountsPartnersPage />}
              />
              {/* <Route
                path={"/Reports/wagesAccount"}
                render={() => <WagesAccount />}
              /> */}
              <Route
                path={"/Reports/wagesAccount"}
                render={() => <WagesAccountPage />}
              />
              {/* <Route
                path={"/Reports/rentAccounts"}
                render={() => <RentAccounts />}
              /> */}
              <Route
                path={"/Reports/rentAccounts"}
                render={() => <RentAccountsPage />}
              />
              {/* Accounting Menu------------------------------------------------------------------ */}
              <Route
                path={"/accounting/accountingsheets"}
                component={AccountingSheetList}
              />
              <Route
                path={"/accounting/addaccountingsheets"}
                component={AddAccountingSheet}
              />
              <Route
                path={"/accounting/entrysheet"}
                render={() => <FletHyrje />}
              />
              <Route
                path={"/accounting/insertentrysheet"}
                render={() => <InsertEntrySheet />}
              />
              <Route
                path={"/accounting/exitsheet"}
                render={() => <FletDalja />}
              />
              <Route
                path={"/accounting/insertexitsheet"}
                render={() => <InsertExitSheet />}
              />

              {/* Money--------------------------------------------------------------------------- */}
              {/* <Route
                path={"/money/receivables"}
                render={() => <Receivables />}
              /> */}
              <Route
                path={"/money/receivables"}
                render={() => <ReceivablesPage />}
              />
              <Route
                path={"/money/addreceivables"}
                render={() => <ReceivablesForm />}
              />
              <Route
                exact
                path={"/money/editreceivables/:transactionId"}
                render={() => <ReceivablesForm />}
              />
              {/* <Route path={"/money/payments"} render={() => <Payments />} /> */}
              <Route path={"/money/payments"} render={() => <PaymentsPage />} />

              {/* <Route
                path={"/money/addpayments"}
                render={() => <AddPayments />}
              /> */}

              <Route
                path={"/money/addpayments"}
                render={() => <PaymentsForm />}
              />
              <Route
                exact
                path={"/money/editpayments/:transactionId"}
                render={() => <PaymentsForm />}
              />
              {/* <Route path={"/money/withdrawal"} render={() => <Withdrawal />} /> */}
              <Route
                path={"/money/withdrawal"}
                render={() => <WithdrawalPage />}
              />

              {/* <Route
                path={"/money/addwithdrawal"}
                render={() => <AddWithdrawal />}
              /> */}

              <Route
                path={"/money/addwithdrawal"}
                render={() => <WithdrawalForm />}
              />
              <Route
                exact
                path={"/money/editwithdrawal/:transactionId"}
                render={() => <WithdrawalForm />}
              />
              {/* <Route path={"/money/transfers"} render={() => <Transfers />} /> */}
              <Route
                exact
                path={"/money/cash-reconciliation"}
                render={() => <SalesReconciliationPage />}
              />
              <Route
                path={"/money/transfers"}
                render={() => <TransfersPage />}
              />

              {/* <Route
                path={"/money/addtransfers"}
                render={() => <AddTransfer />}
              /> */}

              <Route
                path={"/money/addtransfers"}
                render={() => <TransfersForm />}
              />
              <Route
                exact
                path={"/money/edittransfers/:transactionId"}
                render={() => <TransfersForm />}
              />
              {/* <Route
                path={"/money/capitalDeposit"}
                render={() => <CapitalDeposite />}
              /> */}
              <Route
                path={"/money/capitalDeposit"}
                render={() => <CapitalDepositePage />}
              />
              {/* <Route
                path={"/money/addCapitalDeposit"}
                render={() => <AddCapitalDeposit />}
              /> */}
              <Route
                path={"/money/addCapitalDeposit"}
                render={() => <CapitalDepositForm />}
              />
              <Route
                exact
                path={"/money/editCapitalDeposit/:transactionId"}
                render={() => <CapitalDepositForm />}
              />
              {/* Produc Menu------------------------------------------------------------------ */}
              {/* <Route
                path={"/produc/compoundArticle"}
                render={() => <CompoundArticle />}
              /> */}
              <Route
                path={"/produc/compoundArticle"}
                render={() => <CompoundArticlePage />}
              />
              {/* <Route path={"/produc/produce"} render={() => <Produce />} />
                <Route path={"/produc/newProduce"} render={() => <NewProduce />} /> */}
              <Route exact path="/millproduc/normativ" render={() => <MillNormativ />} />
              <Route exact path="/millproduc/newNormativ" render={() => <NewMillNormativ />} />
              <Route exact path="/millproduc/produce" render={() => <MillProduce />} />
              <Route exact path="/millproduc/newProduce" render={() => <NewMillProduce />} />
              {/* <Route
                path={"/millproduc/normativ"}
                render={() => <MillNormativ />}
              /> */}
              {module === "Mill_Module" ? (
                <>
                  <Route
                    path={"/produc/normativ"}
                    render={() => <MillNormativ />}
                  />
                  <Route
                    path={"/produc/newNormativ"}
                    render={() => <NewMillNormativ />}
                  />
                  <Route
                    path={"/produc/produce"}
                    render={() => <MillProduce />}
                  />
                  <Route
                    path={"/produc/newProduce"}
                    render={() => <NewMillProduce />}
                  />
                </>
              ) : (
                <>
                  {/* <Route
                    path={"/produc/normativ"}
                    render={() => <Normativ />}
                  /> */}
                  <Route
                    path={"/produc/normativ"}
                    render={() => <StandardNormativPage />}
                  />
                  {/* <Route
                    path={"/produc/newNormativ"}
                    render={() => <NewNormativ />}
                  /> */}
                  <Route
                    exact
                    path={"/produc/newNormativ/edit/:articleProductionID"}
                    render={() => <StandardNormativForm mode="edit" />}
                  />
                  <Route
                    exact
                    path={"/produc/newNormativ"}
                    render={() => <StandardNormativForm mode="create" />}
                  />

                  {/* <Route path={"/produc/produce"} render={() => <Produce />} /> */}
                  <Route
                    path={"/produc/produce"}
                    render={() => <StandardProducePage />}
                  />

                  {/* <Route
                    path={"/produc/newProduce"}
                    render={() => <NewProduce />}
                  /> */}
                  <Route
                    path={"/produc/newProduce"}
                    render={() => <StandardProduceForm />}
                  />
                </>
              )}

              {/* Configuration Menu--------------------------------------------------------------*/}
              <Route
                path={"/configuration/vatrates"}
                component={VATRatesCruds}
              />
              <Route path={"/configuration/states"} component={StatesCrud} />
              <Route path={"/configuration/cities"} component={CitiesCrud} />
              <Route path={"/configuration/ledgers"} component={Ledgers} />
              <Route
                path={"/configuration/licencedbanks"}
                component={LicencedBanksList}
              />
              {/* <Route
                path={"/configuration/company"}
                component={CompaniesList}
              /> */}
              <Route
                path={"/configuration/company"}
                render={() => <CompaniesPage />}
              />
              {/* <Route
                path={"/configuration/newCompany"}
                render={() => <NewCompany />}
              /> */}
              <Route
                path={[
                  "/configuration/newCompany/edit/:companyId",
                  "/configuration/newCompany",
                ]}
                render={() => <NewCompanyForm />}
              />
              <Route
                path={"/configuration/newLicense"}
                render={() => <NewLicens />}
              />
              <Route
                path={"/configuration/licenses"}
                render={() => <LicensesPage />}
              />
              <Route
                path={["/configuration/product-renewals", "/configuration/bar-tree-renewals"]}
                render={() => <ProductRenewalsPage />}
              />

              <Route
                path={"/configuration/companyunits"}
                component={CompanyUnitLists}
              />
              <Route path={"/configuration/users"} component={UsersList} />
              {/* <Route path={"/configuration/profile"} component={Profile} /> */}
              <Route
                path={"/configuration/profile"}
                render={() => <CompanyProfilePage />}
              />
              {/* <Route
                path={"/configuration/coverpage"}
                render={() => <CoverPage />}
              /> */}
              <Route
                path={"/configuration/coverpage"}
                render={() => <FolderTemplatesPage />}
              />
              <Route
                path={"/configuration/fiscalCashRegister"}
                render={() => <FiscalCashRegister />}
              />
              <Route
                path={"/configuration/notification"}
                render={() => <Notification />}
              />
              <Route
                path={"/configuration/menuItems"}
                render={() => <MenuItemsPage />}
              />

              <Route
                path={"/ordinance/users"}
                render={() => <InsertNewOrdinanceUser />}
              />

              {/* <Route path={"/configuration/folders"} render={() => <FolderatFizik />} /> */}

              {/* Accounting Books--------------------------------------------------------------*/}
              {/* <Route
                path={"/accountingbooks/salesbook"}
                component={SalesBookList}
              /> */}
              <Route
                path={"/accounting/salesbook"}
                render={() => <SalesBookPage />}
              />
              {/* <Route
                path={"/accounting/expencebook"}
                component={ExpenceBookList}
              /> */}
              <Route
                path={"/accounting/expencebook"}
                render={() => <ExpenceBookPage />}
              />
              {/* <Route
                path={"/accounting/purchasebook"}
                component={PurchaseBookList}
              /> */}
              <Route
                path={"/accounting/purchasebook"}
                render={() => <PurchaseBookPage />}
              />
              {/* <Route
                path={"/accounting/investmentbook"}
                component={InvestmentBookList}
              /> */}
              <Route
                path={"/accounting/investmentbook"}
                render={() => <InvestmentBookPage />}
              />
              {/* <Route
                path={"/accounting/journalhistory"}
                render={() => <JournalHistory />}
              /> */}
              <Route
                path={"/accounting/journalhistory"}
                render={() => <JournalHistoryPage />}
              />
              {/* <Route
                path={"/accounting/inventory"}
                render={() => <Inventory />}
              /> */}
              <Route
                path={"/accounting/inventory"}
                render={() => <InventoryPage />}
              />
              {/* Tax Reports-----------------------------------------------------------------  */}
              {/* <Route path={"/tax/salesbook"} render={() => <TaxSalesBook />} /> */}
              <Route
                path={"/tax/salesbook"}
                render={() => <TaxSalesBookPage />}
              />

              {/* <Route
                path={"/tax/purchasebook"}
                render={() => <TaxPurchaseBook />}
              /> */}
              <Route
                path={"/tax/purchasebook"}
                render={() => <TaxPurchaseBookPage />}
              />
              {/* <Route
                path={"/tax/vatdeclaration"}
                render={() => <VATDeclaration />}
              /> */}

              <Route
                path={"/tax/vatdeclaration"}
                render={() => <VatDeclarationPage />}
              />
              <Route
                path={"/tax/vat-monthly-synthetic"}
                render={() => <VATMonthlySyntheticPage />}
              />
              {/* <Route
                path={"/tax/annualdeclaration"}
                render={() => <AnnualDeclaration />}
              /> */}
              <Route
                path={"/tax/annualdeclaration"}
                render={() => <AnnualDeclarationPage />}
              />
              {/* <Route
                path={"/tax/taxwagesreport"}
                render={() => <TaxWagesReport />}
              /> */}
              <Route
                path={"/tax/taxwagesreport"}
                render={() => <TaxWagesReportPage />}
              />
              <Route
                path={"/tax/changesInEquity"}
                render={() => <NdryshimiEkuitetit />}
              />

              {/* Finance Statement------------------------------------------------------------  */}
              {/* <Route
                path={"/financestatements/TrialBalance"}
                render={() => <TrialBalance />}
              /> */}
              <Route
                path={"/financestatements/TrialBalance"}
                render={() => <TrialBalancePage />}
              />
              {/* <Route
                path={"/financestatements/balancesheet"}
                render={() => <BalanceSheet />}
              /> */}
              <Route
                path={"/financestatements/balancesheet"}
                render={() => <BalanceSheetPage />}
              />
              {/* <Route
                path={"/financestatements/incomestatements"}
                render={() => <IncomeStatements />}
              /> */}
              <Route
                path={"/financestatements/incomestatements"}
                render={() => <IncomeStatementPage />}
              />

              <Route
                path={"/financestatements/cashflow"}
                render={() => <CashFlowPage />}
              />
              <Route
                path={"/financestatements/equitychanges"}
                render={() => <EquityChangesPage />}
              />
              <Route
                path={"/financestatements/notes"}
                render={() => <FinancialStatementsNotes />}
              />
              {/* <Route
                path={"/financestatements/MonthlySalesReport"}
                render={() => <MonthlySalesReport />}
              /> */}
              <Route
                path={"/financestatements/MonthlySalesReport"}
                render={() => <MonthlySalesReportPage />}
              />
              <Route
                path={"/financestatements/MonthlyPurchaseReport"}
                render={() => <MonthlyPurchaseReportPage />}
              />
              <Route
                path={"/financestatements/MonthlyExpenseReport"}
                render={() => <MonthlyExpenseReportPage />}
              />
              <Route
                path={"/financestatements/MonthlyWagesReport"}
                render={() => <MonthlyWagesReportPage />}
              />
              {/* <Route
                path={"/financestatements/MonthlyRentReport"}
                render={() => <MonthlyRentReport />}
              /> */}
              <Route
                path={"/financestatements/MonthlyRentReport"}
                render={() => <MonthlyRentReportPage />}
              />
              <Route
                path={"/financestatements/MonthlyExpenseClassReport"}
                render={() => <MonthlyExpenseClassReportPage />}
              />
              <Route
                path={"/financestatements/MonthlyInterestReport"}
                render={() => <MonthlyInteresReportPage />}
              />
              <Route
                path={"/financestatements/fixedAssetReport"}
                render={() => <FixedAssetsPage />}
              />

              {/* Fillo Vitin Fiskal------------------------------------------------------------  */}
              <Route
                path={"/newFiscalYear/transferAccounts"}
                render={() => <BartjaLlogarive />}
              />
              <Route
                path={"/newFiscalYear/stockTransfer"}
                render={() => <BartjaStokut />}
              />
              <Route
                path={"/newFiscalYear/articleImport"}
                render={() => <ImportimiArtikujve />}
              />
              <Route path={"/newFiscalYear/partnerImport"} render={() => <ImportimiPartnereve />} />

              {/* Kartelat-----------------------------------------------------------------------*/}
              <Route
                path={"/card/clientCard"}
                render={() => <KartelaKlientit />}
              />
                 {/* <Route
                path={"/card/clientCard"}
                render={() => <ClientCardPage />}
              /> */}
              <Route
                path={"/card/supplierCard"}
                render={() => <KartelaFurnitorit />}
              />
              <Route
                path={"/card/agentCard"}
                render={() => <KartelaAgjentit />}
              />
              {/* <Route
                path={"/card/articlesCard"}
                render={() => <KartelaArtikullit />}
              /> */}
              <Route
                path={"/card/articlesCard"}
                render={() => <KartelaArtikullitPage />}
              />
              <Route path={"/print"} component={<PrintContent />} />
              </MenuRouteGate>
              </AuthenticatedPages>
            </LayoutNavbar>
          )}
        </Switch>
      </Router>
    </div>
  );
}

export default App;
